"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BookYourAppointment() {
  return <section id="book-your-appointment" className="relative overflow-hidden bg-dark-background py-24">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="text-[280px] font-display font-bold tracking-tighter opacity-5" style={{
        color: "var(--color-foreground-dark)"
      }}>
          AXION
        </div>
      </div>

      {}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          {}
          <div className="mb-8">
            <h2 className="text-foreground-dark mb-4 animate-fade-in-up">
              Book Your Appointment
            </h2>
            <div className="h-0.5 mx-auto max-w-xs bg-primary animate-[width-grow_var(--duration-medium)_var(--ease-smooth)_forwards]" style={{
            animationName: "width-grow",
            width: "0%"
          }} />
          </div>

          {}
          <div className="animate-fade-in-up" style={{
          animationDelay: "150ms"
        }}>
            <Link to="/BookAppointmentPage">
              <Button size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-[1.03] hover:shadow-strong transition-all duration-[var(--duration-fast)] ease-out px-8 py-4 text-lg font-semibold">
                Schedule Now
              </Button>
            </Link>
          </div>

          <p className="mt-6 text-foreground-dark/80 text-sm animate-fade-in-up" style={{
          animationDelay: "300ms"
        }}>
            Available Saturdays: 9am–5pm
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes width-grow {
          from {
            width: 0%;
          }
          to {
            width: 100%;
          }
        }
      `}</style>
    </section>;
}